var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 184,
    viewBox: "0 0 362 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7013 140.149L0 146.474V185.614H362V44.3445C357.299 38.1606 347.896 25.7928 338.494 29.8555C329.091 33.9183 319.688 54.4117 310.286 65.2644C300.883 76.1172 291.481 77.3293 282.078 74.8498C272.675 72.3702 263.273 66.199 253.87 67.2636C244.468 68.3282 235.065 76.6285 225.662 72.6714C216.26 68.7142 206.857 52.4996 197.455 47.8211C188.052 43.1427 178.649 50.0004 169.247 62.1693C159.844 74.3382 150.442 91.8181 141.039 92.9397C131.636 94.0613 122.234 78.8245 112.831 81.416C103.429 84.0075 94.026 104.427 84.6234 107.417C75.2208 110.407 65.8182 95.9665 56.4156 93.2465C47.013 90.5265 37.6104 99.5269 28.2078 110.352C18.8052 121.176 9.4026 133.825 4.7013 140.149Z",
    fill: "url(#paint0_linear_552_2788)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 146.877L4.7013 140.531C9.4026 134.185 18.8052 121.493 28.2078 110.631C37.6104 99.7691 47.013 90.7378 56.4156 93.4671C65.8182 96.1965 75.2208 110.686 84.6234 107.686C94.026 104.686 103.429 84.1964 112.831 81.596C122.234 78.9956 131.636 94.2848 141.039 93.1593C150.442 92.0339 159.844 74.4938 169.247 62.2831C178.649 50.0724 188.052 43.1911 197.455 47.8856C206.857 52.5802 216.26 68.8506 225.662 72.8213C235.065 76.792 244.468 68.4631 253.87 67.3949C263.273 66.3267 272.675 72.5191 282.078 75.0072C291.481 77.4952 300.883 76.2789 310.286 65.3889C319.688 54.4988 329.091 33.935 338.494 29.8583C347.896 25.7816 357.299 38.1919 362 44.397",
    stroke: "#0FC6C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_552_2788",
    x1: 181,
    y1: 29.0527,
    x2: 181,
    y2: 185.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FC6C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FC6C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/svg3.f75f6f97306a7def0f8a9695b6441e0c.svg";
export { ForwardRef as ReactComponent };